import { render, staticRenderFns } from "./StudentModalAdd.vue?vue&type=template&id=351ddef0&scoped=true"
import script from "./StudentModalAdd.vue?vue&type=script&lang=js"
export * from "./StudentModalAdd.vue?vue&type=script&lang=js"
import style0 from "./StudentModalAdd.vue?vue&type=style&index=0&id=351ddef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ddef0",
  null
  
)

export default component.exports